export const apiURLs = {
	AddImage:"/add-image",
	AddBook:"/add-book",
	AddCategory:"/add-category",
	AddSubject:"/add-subject",
	AddCategorySubject:"/add-category-subjects",
	ListAllSubjects:"/get-all-subjects",
	EditBook:"/edit-book",
	GetBooks:"/get-books",
	GetImage:"/get-image",
  Registration:"/user/registration",
	GetCountry:"/get-countries",
	GetStates:"/get-states",
	Login:"/login",
	AdminList:"/list-users",
	ImageListAdmin:"/list-images-admin",
	ImageListUser:"/list-images-user",
	ImageList:"/list-images",
	ValidUsername: "/user/check-username",
	ValidEmail: "/user/validate-email",
	Profile: "/get-user-details",
	UpdateProfile: "/update-user-details/",
	ForgotPassword: "/forgot-password",
	ResetPassword: "/reset-password",
	ValidateToken: "/validate-token",
	AddToCart:"/add-to-cart",
	CartCount:"/cart-count",
	ViewCollections:"/view-cart",
	GetCategories: "/get-categories",
	RemoveFromCollection:"/remove-item-from-cart",
	RequestPermission:"/request-permission",
	UserWiseRequestImages:"/list-users-requests",
	PendingRequestList:"/list-pending-requests",
	UserRequestView:"/user-request-view",
	UsersList:"/list-users",
	TopRequestedImages:"/top-requests",
	UpdateUserRequest:"/update-user-request",
	DeleteAdminUser: "/delete-admin-user",
	AddAdminUser: "/add-admin-user",
	PreviousRequestList:"/list-previous-requests",
	GetSubjects:"/get-subjects",
	DeleteImage:"/delete-image",
	DeleteBook:"/delete-book",
	SubjectsCategory:"/get-subjects-category",
	GetLatestUploads:"/get-latest-uploads",
	ImageConvert:"/image-convert",
}
